import { VTeamSelector } from '../from_customer_components'
import { defaultFun } from '../utils'
import { TEAM_SELECT } from '../type_name'
import commonMixins from './commonMixins'
import {mapGetters} from "vuex";
export default {
    name: TEAM_SELECT,
    mixins: [ commonMixins ],
    computed: {
        ...mapGetters('async', {
            teams_hash: 'teams_hash',
          }),
    },
    render(h) {
        const _this = this
        const {
                         // eslint-disable-next-line 
             slots,scopedSlots,
             key,
             allowBlank = false,
             blur = defaultFun,
             change = defaultFun,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
        return h(VTeamSelector, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            attrs: {
                ...params
              },
            props: {
                allowBlank,
                value: this.my_value[key]
            },
            on: {
                blur,
                change:(data) => {
                    this.my_value[key] = data
                    change(data, _this.teams_hash[data])
                },
                click,
                focus,
                input,
                keydown,
                mousedown,
                mouseup,
            }
        })
    }
}